var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 62.29 48.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9.94,
    y1: -127.64,
    x2: 62.29,
    y2: -127.64,
    gradientTransform: "translate(0 -103.35) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6cc8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155fee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -569.94,
    y1: -636.87,
    x2: -570.02,
    y2: -626.44,
    gradientTransform: "translate(-579.17 -566.69) rotate(-90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6cc8e6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155fee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9.94,
    y1: -127.64,
    x2: 47,
    y2: -127.64,
    gradientTransform: "translate(0 -103.35) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#155fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6cc8e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 6622.35,
    y1: -6666.71,
    x2: 6622.3,
    y2: -6677.43,
    gradientTransform: "translate(6715.34 -6590.8) rotate(90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6cc8e6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155fee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 22.9,
    y1: -134.84,
    x2: 30.82,
    y2: -134.87,
    gradientTransform: "translate(0 -103.35) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 15.05,
    y1: -133.47,
    x2: 11.07,
    y2: -136.55,
    gradientTransform: "translate(0 -103.35) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00bef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155fee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 5.47,
    y1: -146.42,
    x2: 1.56,
    y2: -150.4,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tests"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m25.41,48.59h-12.15c-1.84,0-3.32-1.49-3.32-3.32s1.49-3.32,3.32-3.32h12.15c2.77,0,5.02-2.25,5.02-5.02v-2.09h-7.24c-1.84,0-3.32-1.49-3.32-3.32s1.49-3.32,3.32-3.32h7.24V8.96c0-4.94,4.02-8.96,8.96-8.96h13.94c4.94,0,8.96,4.02,8.96,8.96v14.6c0,6.21-5.06,11.27-11.27,11.27h-13.94v2.09c0,6.43-5.23,11.66-11.66,11.66Zm11.66-20.4h13.94c2.55,0,4.63-2.08,4.63-4.63v-14.6c0-1.28-1.04-2.31-2.31-2.31h-13.94c-1.28,0-2.31,1.04-2.31,2.31,0,0,0,19.23,0,19.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "44.02 6.63 43.97 .02 54.52 .02 54.52 6.63 44.02 6.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.41,48.59h-12.15c-1.84,0-3.32-1.49-3.32-3.32s1.49-3.32,3.32-3.32h12.15c2.77,0,5.02-2.25,5.02-5.02V8.96c0-4.94,4.02-8.96,8.96-8.96h4.29c1.84,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32h-4.29c-1.28,0-2.31,1.04-2.31,2.31v27.97c0,6.43-5.23,11.66-11.66,11.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "37.08 34.83 37.08 28.19 47.59 28.2 47.59 34.83 37.08 34.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30.43 28.19 30.43 34.83 23.12 34.82 23.12 28.19 30.43 28.19"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 13.26,
    cy: 31.51,
    r: 3.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3.32,
    cy: 45.26,
    r: 3.32
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeum);
export default __webpack_public_path__ + "static/media/Neum.83a8d405ddf66c0963cdd409c1200d8b.svg";
export { ForwardRef as ReactComponent };